import {ServiceBase} from "../ServiceBase";
import {GameThemeDefinition} from "./game-theme-definition/game-theme-definition";
import {GameThemeId} from "./game-theme-id.enum";
import {IGamesThemeService} from "./games-theme.service.interface";

export class GamesThemeService extends ServiceBase implements IGamesThemeService {

    private _allThemes: GameThemeDefinition[] = [
        new GameThemeDefinition(GameThemeId.Adventure, "Adventure", this.services),
        new GameThemeDefinition(GameThemeId.AncientCivilization, "Ancient Civilization", this.services),
        new GameThemeDefinition(GameThemeId.Wildlife, "Wildlife", this.services),
        new GameThemeDefinition(GameThemeId.ClassicStyle, "Classic Style", this.services),
        new GameThemeDefinition(GameThemeId.Asian, "Asian", this.services),
        new GameThemeDefinition(GameThemeId.TableGames, "Table Games", this.services),
        new GameThemeDefinition(GameThemeId.MoviesAndMusic, "Movies and Music", this.services),
        new GameThemeDefinition(GameThemeId.Fruit, "Fruit and Candy", this.services),
        new GameThemeDefinition(GameThemeId.MoneyAndLeisure, "Money and Leisure", this.services),
        new GameThemeDefinition(GameThemeId.ComicsAndCartoons, "Comics and Cartoons", this.services),
        new GameThemeDefinition(GameThemeId.Irish, "Irish", this.services),
        new GameThemeDefinition(GameThemeId.Arcade, "Arcade", this.services),
        new GameThemeDefinition(GameThemeId.DiamondsAndGems, "Diamonds and Gems", this.services),
        new GameThemeDefinition(GameThemeId.FantasyAndFolklore, "Fantasy and Folklore", this.services),
        new GameThemeDefinition(GameThemeId.Seasonal, "Seasonal", this.services),
        new GameThemeDefinition(GameThemeId.Egyptian, "Egyptian", this.services),
        new GameThemeDefinition(GameThemeId.FarmAndPets, "Farm and Pets", this.services),
        new GameThemeDefinition(GameThemeId.Sports, "Sports", this.services),
        new GameThemeDefinition(GameThemeId.LiveCasino, "Live Casino", this.services),
        new GameThemeDefinition(GameThemeId.Arabic, "Arabic", this.services),
        new GameThemeDefinition(GameThemeId.GreekMythology, "Greek Mythology", this.services),
        new GameThemeDefinition(GameThemeId.NA, "N/A", this.services),
        new GameThemeDefinition(GameThemeId.SpaceAndSciFi, "Space and Sci-fi", this.services),
        new GameThemeDefinition(GameThemeId.ScratchCards, "Scratch Cards", this.services),
        new GameThemeDefinition(GameThemeId.Fish, "Fish", this.services),
        new GameThemeDefinition(GameThemeId.Mexican, "Mexican", this.services),
        new GameThemeDefinition(GameThemeId.Xmas, "Xmas", this.services),
        new GameThemeDefinition(GameThemeId.Bingo, "Bingo", this.services),
        new GameThemeDefinition(GameThemeId.ClassicStyleModernized, "Classic Style Modernized", this.services),
        new GameThemeDefinition(GameThemeId.AztecIncaMayan, "Aztec Inca Mayan", this.services),
        new GameThemeDefinition(GameThemeId.Crime, "Crime", this.services),
        new GameThemeDefinition(GameThemeId.WildWest, "Wild West", this.services),
        new GameThemeDefinition(GameThemeId.CandyAndSweets, "Candy And Sweets", this.services),
        new GameThemeDefinition(GameThemeId.GoldMining, "Gold Mining", this.services),
        new GameThemeDefinition(GameThemeId.VikingsAndNordicMythology, "Vikings And Nordic Mythology", this.services),
    ]

    findThemes(regEx: RegExp): number[] {
        const foundThemes: number[] = [];

        this._allThemes.forEach(theme => {
            if (theme.isMatch(regEx)) {
                foundThemes.push(theme.id)
            }
        })

        return foundThemes;
    }

    getGameThemeDefinition(gameThemeId: number): GameThemeDefinition {
        return this._allThemes.find(gameThemeDefinition => gameThemeDefinition.id === gameThemeId);
    }
}